import { RecipeOriginType } from '../../../enums/RecipeOriginType';
import { SaveRecipeInputBase } from '../../../models/SaveRecipeInputBase';

export class NewLooseCustomerRecipeInput extends SaveRecipeInputBase {
  name?: string;
  description?: string;
  createdAt: string;
  approvedAt?: string;
  origin: RecipeOriginType;
  relatedZerezesCustomerRecipeId?: number;
  customerShopifyId: number;
  customerRecipeId?: number;
}